export default "__VITE_ASSET__DM0$r5CH__"